import React from 'react'

const WidgetsLoader = () => {
  return (
    <div>index</div>
  )
}

export default WidgetsLoader